<template>
  <div class="container flex-column">
    <v-alert id="alert_proceso" v-if="bSelectTrasicion" text color="info" >
      <h4>Proceso Seleccionado</h4>
    </v-alert>  

    <div v-if="oInfoProceso && oInfoProceso.sLlave" class="my-3">
      <v-btn id="btn_historico" @click="bShowHistorico = true" color="primary" block>
        Ver Histórico
      </v-btn>
      <HistoricoProceso 
        v-model="bShowHistorico"
        :idProceso="$route.params.idProceso"
        :sLlave="oInfoProceso.sLlave"
      />
    </div>

    <ListCardProceso id="List_Procesos" v-if="bSelectTrasicion" :items="[oInfoProceso]"></ListCardProceso>
    

    <v-alert id="alert_info" v-if="bSelectTrasicion" text color="info"  class="my-3">
      <div>Selecciones el paso a seguir</div>
    </v-alert>  

    <div v-if="bSelectTrasicion" class="container my-3">
      <Transiciones id="idTransiciones" :aTransiciones="aTransiciones" @transicion="Goto_transicion"></Transiciones>
    </div>
    <DiligenciarFD id="DiligenciarFD" v-if="!bSelectTrasicion" 
      :nIdFormulario_props="cmp_GetID_Form"
      :sTransicion_props="sTransicion"
      :oProcesoEnCurso="$route.query.infoProceso"
    ></DiligenciarFD>
  </div>  
</template>

<script>
import axiosServices from "@/services/axiosServices.js"

import Transiciones from '@/components/workflow/Transiciones.vue';
import DiligenciarFD from '@/components/workflow/DiligenciarFD.vue';
import ListCardProceso from "@/components/workflow/ListCardProceso.vue";
import HistoricoProceso from '@/components/workflow/HistoricoProceso.vue';

import { mapGetters } from 'vuex';

export default {
  name: 'ProcesoViewDetalle',
  components: {
    Transiciones,
    DiligenciarFD,
    ListCardProceso,
    HistoricoProceso
  },
  data(){
    return {
      oInfoProceso : this.$route.query.infoProceso,
      aTransiciones : [],
      bDiligenciarFD : false,
      sTransicion_Select : '',
      bShowHistorico: false,
    }
  },
  async mounted() {
      if (this.$route.name === 'ProcesoViewDetalle') {
      history.pushState(null, null, location.href);
      this._preventBack = () => {
        if (!window.__workflowGoingBack) {
          history.pushState(null, null, location.href);
        }
        window.__workflowGoingBack = false;
      };
      window.addEventListener('popstate', this._preventBack);
      this.$store.dispatch('setbNavegacion', true);
      this.$store.dispatch('setNavegacionBack', 'ProcesoDetalle');
    }

    const oResponse = await axiosServices.getConfiguration(`workflow/${this.$route.params.idProceso}/transiciones/${this.oInfoProceso.sEstadoProceso}`, true )

    if(oResponse.nStatusCode==200 ){
      this.aTransiciones = oResponse.aData
    }
  },
  computed: {
    ...mapGetters(['getimei', 'getisAPP']),
    ...mapGetters('str_Procesos',['getaInfoProceso']),

    sTransicion() {
      return this.aTransiciones.length === 1
        ? this.aTransiciones[0]
        : this.sTransicion_Select;
    },
    
    bSelectTrasicion(){
      return this.aTransiciones.length !== 1 && !this.bDiligenciarFD;
    },
    cmp_GetID_Form() {
      if ( !this.sTransicion || !this.getaInfoProceso || !this.getaInfoProceso.Transitions ) {
        return 0;
      }

      const transitions = this.getaInfoProceso.Transitions;
      const selectedKey = this.sTransicion;

      // se busca si en transitions esta la tansición y si esta se obtiene su index
      const indexTransition = Object.keys(transitions).find(
        key => key.trim().toLowerCase() === selectedKey.trim().toLowerCase()
      );

      if (!indexTransition) {
        return 0;
      }

      return  transitions[indexTransition].form_id;
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this._preventBack);
    this.$store.dispatch('setbNavegacion', false);
  },
  methods: {
    Goto_transicion(item) {
      this.sTransicion_Select = item;
      this.bDiligenciarFD = true;
      this.aTransiciones = [item];
    }
  }
}
</script>

<style lang="scss" scoped>

</style>